import { base } from '@modules';

import { RolesSchema } from './Roles.schema';

export const initialState: RolesSchema = {
  all: { ...base.state, data: [] },
};
